import * as React from 'react';
import { observer } from 'mobx-react';

import Reference from 'shared/newComponents/Reference';
import { usePaymentStore } from 'stores';
import TypedTransComponent from 'shared/components/TypedTransComponent';
import { PopupTrigger } from 'shared/entities/components/Popup';

type Props = {
  trigger?: PopupTrigger;
};

const CabinetBalanceInfoReference: React.FC<Props> = ({ trigger }) => {
  const paymentStore = usePaymentStore();

  if (!paymentStore.info || !paymentStore.info.isTrialOver) {
    return null;
  }

  return (
    <Reference
      className="reference-item"
      trigger={trigger}
      title={
        <TypedTransComponent
          ns="newComponents"
          i18nKey="CabinetBalanceInfo.content"
          count={paymentStore.info.daysLeft}
        >
          Баланса хватит на&nbsp;
          {{
            daysLeft: paymentStore.info.daysLeft
          }}{' '}
          день использования сервиса.
          <br />
          Стоимость подписки будет списана с&nbsp;карты автоматически.
        </TypedTransComponent>
      }
    />
  );
};

export default observer(CabinetBalanceInfoReference);
